import { useState } from 'react';
import { MessageCircle, X, Phone, MessageSquare, Mail } from 'lucide-react';

export default function FloatingContactButton() {
  const [isOpen, setIsOpen] = useState(false);

  const phoneNumber = '8303599925';
  const formattedPhone = '(830) 359-9925';
  const email = 'orders@comalglass.com';

  const contactOptions = [
    {
      icon: Phone,
      label: 'Call Us',
      sublabel: formattedPhone,
      href: `tel:${phoneNumber}`,
      color: 'bg-green-500 hover:bg-green-600',
    },
    {
      icon: MessageSquare,
      label: 'Text Us',
      sublabel: formattedPhone,
      href: `sms:${phoneNumber}`,
      color: 'bg-blue-500 hover:bg-blue-600',
    },
    {
      icon: Mail,
      label: 'Email Us',
      sublabel: 'Get a quote',
      href: `mailto:${email}?subject=Quote Request from Website`,
      color: 'bg-purple-500 hover:bg-purple-600',
    },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Contact Options Popup */}
      <div
        className={`absolute bottom-16 right-0 transition-all duration-300 ${
          isOpen
            ? 'opacity-100 translate-y-0 pointer-events-auto'
            : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden w-64">
          {/* Header */}
          <div className="bg-gradient-to-r from-cyan-500 to-cyan-600 px-4 py-3">
            <p className="text-white font-semibold">How can we help?</p>
            <p className="text-cyan-100 text-sm">Choose how to reach us</p>
          </div>

          {/* Options */}
          <div className="p-2">
            {contactOptions.map((option, index) => {
              const Icon = option.icon;
              return (
                <a
                  key={index}
                  href={option.href}
                  className="flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 transition-colors group"
                  onClick={() => setIsOpen(false)}
                >
                  <div className={`p-2 rounded-full ${option.color} transition-colors`}>
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <p className="font-medium text-gray-900 group-hover:text-cyan-600 transition-colors">
                      {option.label}
                    </p>
                    <p className="text-sm text-gray-500">{option.sublabel}</p>
                  </div>
                </a>
              );
            })}
          </div>

          {/* Footer */}
          <div className="px-4 py-3 bg-gray-50 border-t border-gray-100">
            <p className="text-xs text-gray-500 text-center">
              We typically respond within 1 hour
            </p>
          </div>
        </div>

        {/* Arrow pointer */}
        <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-r border-b border-gray-100 transform rotate-45" />
      </div>

      {/* Main Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`group relative flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-all duration-300 ${
          isOpen
            ? 'bg-gray-700 hover:bg-gray-800 rotate-0'
            : 'bg-gradient-to-r from-cyan-500 to-cyan-600 hover:from-cyan-600 hover:to-cyan-700'
        }`}
        aria-label={isOpen ? 'Close contact options' : 'Open contact options'}
      >
        {/* Pulse animation when closed */}
        {!isOpen && (
          <>
            <span className="absolute inset-0 rounded-full bg-cyan-400 animate-ping opacity-25" />
            <span className="absolute inset-0 rounded-full bg-cyan-400 animate-pulse opacity-20" />
          </>
        )}

        {/* Icon */}
        <div className="relative z-10 transition-transform duration-300">
          {isOpen ? (
            <X className="w-6 h-6 text-white" />
          ) : (
            <MessageCircle className="w-6 h-6 text-white" />
          )}
        </div>

        {/* Tooltip when closed */}
        {!isOpen && (
          <div className="absolute right-full mr-3 px-3 py-1.5 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
            Contact Us
            <div className="absolute top-1/2 -right-1 w-2 h-2 bg-gray-900 transform rotate-45 -translate-y-1/2" />
          </div>
        )}
      </button>
    </div>
  );
}
